<template>
  <div class="d-inline-block">
    <template v-for="category in categories">
      <v-btn
        :key="category.value"
        small
        class="ma-1"
        :color="value != category.value ? 'grey' : 'primary'"
        depressed
        :outline="value != category.value"
        @click="$emit('onChangeCategory', category.value)"
        v-if="category.value == 'all' || (category.value != 'all' && stat[category.value] > 0)"
      >
        {{ $t(category.text) }}
        <template v-if="stat[category.value] > 0">({{ stat[category.value] }})</template>
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'stat'],

  computed: {
    ...mapGetters(['selectedBot']),
    categories() {
      var categories = [
        {
          text: 'All',
          value: 'all'
        }
      ]
      if (this.selectedBot.theme !== 'runkan') {
        categories.concat([
          {
            text: 'almost sold out',
            value: 'soldout'
          },
          {
            text: 'Sale',
            value: 'sales'
          }
        ])
      }
      return categories
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/DefaultCategory.vue